// metadata/types.ts
function unwrapType(type) {
  return () => unwrapTypeRec(type());
}
function unwrapTypeRec(type) {
  return Array.isArray(type) ? unwrapTypeRec(type[0]) : type;
}
function getArrayDepth(type) {
  return () => getArrayDepthRec(type());
}
function getArrayDepthRec(type, depth = 0) {
  return Array.isArray(type) ? getArrayDepthRec(type[0], depth + 1) : depth;
}
export {
  getArrayDepth,
  unwrapType
};
